export default "__VITE_ASSET__yflNyFOn__"